module.exports = __webpack_public_path__ + "media/images/tmp-graph-006892f69dfff8dd3397acd3f59de9a4.jpg";